import { STRAPI_CONTENT_URL } from 'strapi/constants';

import { ImageInfo, MediaComponent, MediaImageComponent } from './types';

export function collectImageComponentParams(
  media: MediaImageComponent
): ImageInfo;
export function collectImageComponentParams(
  media?: MediaComponent | null
): ImageInfo | undefined;

export function collectImageComponentParams(
  media?: MediaComponent | null
): ImageInfo | undefined {
  if (!media || !media.mime?.startsWith('image')) {
    return undefined;
  }

  return {
    filename: media.name,
    alt: media.alternativeText ?? undefined,
    width: media.width,
    height: media.height,
    url: media.url,
    provider: media.provider,
  };
}

export const collectVideoUrl = (
  media?: MediaComponent | null
): string | undefined => {
  if (!media || !media.mime?.startsWith('video')) {
    return undefined;
  }

  return media.provider === 'local'
    ? `${STRAPI_CONTENT_URL}${media.url}`
    : media.url;
};
